import React, { useRef } from 'react';
import '../../css/HotelListModal.css';
import PreviewPDF from './PreviewPDF';
import { Client, TripInfo, ItineraryItem } from '../../types/Quotation';
import { generatePdf } from '../../utils/pdf';

interface PDFPreviewModalProps {
  client?: Client;
  tripInfo: TripInfo;
  itinerary: ItineraryItem[];
  highlights?: string;
  onClose: () => void;
}

const PDFPreviewModal: React.FC<PDFPreviewModalProps> = ({
  client = { name: '', phoneNumber: '', email: '' },
  tripInfo,
  itinerary,
  highlights = '',
  onClose,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const handlePrint = () => {
    const el = contentRef.current;
    if (!el) return;
    const filename = `${client?.name || 'Sir_Mam'}-${tripInfo.title || 'Quotation-OTA Prime'}.pdf`;
    generatePdf(el, filename);
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal hotel-modal pdf-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '900px', width: '90vw', maxHeight: '90vh', overflow: 'auto' }}>
        <button className="close-btn" onClick={onClose}>×</button>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>Quotation Preview</h3>
          <button className="hs-search-btn" onClick={handlePrint}>Download PDF</button>
        </div>
        <div ref={contentRef}>
          <PreviewPDF
            client={client}
            tripInfo={tripInfo}
            itinerary={itinerary}
            generalRules={''}
            highlights={highlights}
            highlightImages={[]}
            inclusionImages={[]}
            itineraryImages={[]}
          />
        </div>
      </div>
    </div>
  );
};

export default PDFPreviewModal;
